import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedMixpanelService {

  constructor() {
    mixpanel.init(environment.MIXPANEL_KEY, { debug: environment.production });
  }
  actions = {
    identify: (id) => {
      mixpanel.identify(id);
    },
    alias: (id) => {
      mixpanel.alias(id);
    },
    track: (name, props) => {
      mixpanel.track(name, props);
    },
    people: {
      set: (props) => {
        mixpanel.people.set(props);
      },
    },
    reset: () => {
      mixpanel.reset();
    }
  };
}
